angular.module('b2bLoginApp.directives').directive('infobar', function() {
    return {
        template: '<div class="infobar" ng-include="getTemplateUrl()"></div>',
        controller: ["$scope", "$route", function($scope, $route) {
            $scope.getTemplateUrl = function () {
                if ( ! $route.current) {
                    return '/account/infobar/infobar.html';
                }
                switch ($route.current.loadedTemplateUrl) {
                    case '/account/areas/areas.html':
                        return '/account/infobar/areas.html';
                    case '/account/company-profile/company-profile.html':
                        return '/account/infobar/company-profile.html';
                    case '/account/faq/help-desk.html':
                        return '/account/infobar/help-desk.html';
                    case '/account/company-profile-public/company-profile.html':
                        return null;
                    case '/account/referral/referral.html':
                        return null;
                    default:
                        return '/account/infobar/infobar.html';
                }
            };
        }]
    };
});
